import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useEffect } from "react";
import FullPageSpinner from "@/components/FullPageSpinner/index.ts";
import AuthError from "./AuthError.tsx";

type Props = {
    children: ReactNode;
};

const AuthGuard = ({ children }: Props): ReactNode => {
    const location = useLocation();
    const { isAuthenticated, isLoading, loginWithRedirect, error } = useAuth0();
    const guestRoute = location.pathname.startsWith("/guest");

    useEffect(() => {
        if (isLoading || isAuthenticated || error || guestRoute) {
            return;
        }

        void loginWithRedirect();
    }, [isLoading, isAuthenticated, error, loginWithRedirect, guestRoute]);

    if (error) {
        return <AuthError error={error} />;
    }

    if (isAuthenticated || guestRoute) {
        return children;
    }

    return <FullPageSpinner />;
};

export default AuthGuard;
